import React from "react";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

const ProjectCard = ({ project }) => {
  const {
    id,
    projectImg,
    projectName,
    siteLink,
    clientCode,
    serverCode,
    previewTxt,
    techStack,
  } = project;
  return (
    <div className="flex lg:flex-row md:flex-col sm:flex-col flex-col lg:gap-16 md:gap-10 lg:mb-0 md:mb-16 sm:mb-16 mb-12 items-center top-0 sm:mx-auto">
      <div className="lg:w-1/2 md:w-full sm:w-11/12 w-11/12 mb-8 shadow-xl image-full">
        <figure>
          <PhotoProvider>
            <PhotoView src={projectImg}>
              <img
                src={projectImg}
                alt="project"
                className="hover:scale-105 transition-all ease-in-out delay-75 duration-500 rounded-2xl hover:bottom-0"
              />
            </PhotoView>
          </PhotoProvider>
        </figure>
      </div>
      <div className="flex flex-col items-stretch">
        <h2 className="text-accent lg:text-start md:text-center sm:text-center text-center text-2xl pb-4 font-semibold hover:scale-110 hover:-rotate-1 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
          {projectName}
        </h2>
        <div className="flex lg:justify-start md:justify-center sm:justify-center justify-center gap-3 mb-6">
          <a
            href={siteLink}
            target="_blank"
            rel="noreferrer"
            className="text-green-400 border-b-green-400 text-sm border-b-2 hover:border-green-300 hover:text-green-300 transition-all ease-in-out duration-700 hover:cursor-pointer"
          >
            LIVE SITE
          </a>
          <a
            href={clientCode}
            target="_blank"
            rel="noreferrer"
            className="text-green-400 border-b-green-400 text-sm border-b-2 hover:border-green-300 hover:text-green-300 transition-all ease-in-out duration-700 hover:cursor-pointer"
          >
            CLIENT CODE
          </a>
          <a
            href={serverCode}
            target="_blank"
            rel="noreferrer"
            className="text-green-400 border-b-green-400 text-sm border-b-2 hover:border-green-300 hover:text-green-300 transition-all ease-in-out duration-700 hover:cursor-pointer"
          >
            SERVER CODE
          </a>
        </div>
        <p className="lg:text-start md:text-center sm:text-center text-center">
          {previewTxt}
        </p>
        <div className="flex gap-2 flex-wrap my-4 sm:justify-center">
          {techStack.map((tech) => (
            <div className="badge badge-outline badge-accent text-primary font-medium">
              {tech}
            </div>
          ))}
        </div>
        <Link
          to={`/projects/${id}`}
          className="text-sm border-b-2 border-b-green-400 text-green-400 hover:border-green-300 hover:text-green-300 transition-all ease-in-out duration-700 hover:cursor-pointer flex gap-2 items-center lg:justify-end sm:justify-center justify-center mt-6 lg:mx-0 sm:mx-auto mx-auto"
        >
          VIEW CASE STUDY
          <BsArrowRight></BsArrowRight>
        </Link>
      </div>
    </div>
  );
};

export default ProjectCard;
